import React, { useMemo, useState } from 'react';

import Choice from './Choice';
import FilterSectionChoice from './FilterSectionChoice';
import type { IFilterAttributeChoice, IFilterAttributeChoiceValue } from './types';

interface IProps extends IFilterAttributeChoice {
  onChange: (urlKey: string, id: string, checked: boolean) => void;
}

const previewOptionsLimit = 5;

export default function FilterSectionAttributeChoice(props: IProps) {
  const [isOpen, setIsOpen] = useState(false);

  const previewOptions = useMemo(() => {
    const top = props.choices.filter(t => !t.isSelected).slice(0, 5);
    const selected = props.choices.filter(t => t.isSelected);

    if (selected.length >= previewOptionsLimit) return selected;

    return [...selected, ...top]
      .slice(0, previewOptionsLimit)
      .sort((a, b) => a.sortOrder - b.sortOrder);
  }, [props.choices]);

  const choices = useMemo(
    () => (!isOpen ? previewOptions : props.choices),
    [isOpen, previewOptions, props.choices]
  );

  const renderChoice = (choice: IFilterAttributeChoiceValue) => (
    <Choice
      key={choice.choiceId}
      id={choice.choiceId}
      name={choice.choiceName}
      productsCount={choice.productCount}
      isSelected={choice.isSelected}
      onChange={(id, checked) => props.onChange(props.queryKey, id, checked)}
    />
  );

  return (
    <FilterSectionChoice
      title={props.attributeName}
      choices={choices.map(renderChoice)}
      showBtnExpand={props.choices.length > previewOptionsLimit}
      isOpen={isOpen}
      onToggleOpen={() => setIsOpen(state => !state)}
    />
  );
}
